import React, { Component } from "react";
import { connect } from "react-redux";
import { signOut, signOutAuth } from "../../actions/authAction";
import { clearTranslate } from "../Navbar/gtUtils";
import { Redirect } from "react-router-dom";
import { getAccessToken } from "../../actions/utils";

class SignOut extends Component {
    componentDidMount() {
        let isSessionTimedOut = sessionStorage.getItem("isSessionTimedOut");
        this.props.signOut();
        this.props.signOutAuth(getAccessToken());
        localStorage.clear();
        sessionStorage.clear();
        clearTranslate();
        if (isSessionTimedOut != null || isSessionTimedOut != undefined) {
            sessionStorage.setItem("isSessionTimedOut", isSessionTimedOut);
        }
    }

    render() {
        return this.props.isAgencySigningOut ? <Redirect to="/wlsignin" /> : <Redirect to="/signin" />;
    }
}

const mapStateToProps = (state) => {
    return {
        isAgencySigningOut: state.globalReducer.company?.whitelabel_logo,
    };
};

const mapDispatchToProps = (dispatch) => ({
    signOut: () => {
        dispatch(signOut());
        setTimeout(() => dispatch({ type: "USER_LOGOUT" }), 1000);
    },
    signOutAuth: (data) => dispatch(signOutAuth(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignOut);
